export interface IScreenshotSettings {
  id?: string;
  width?: number | undefined | null;
  height?: number | undefined | null;
  legendVisible?: boolean;
  legendLabelSize?: number | undefined | null;
  legendFontSize?: number | undefined | null;
  mapScreenshotScale?: number | undefined | null;
  automation?: boolean;
  /** EVA-127 "Simplify Custom Field Names" screenshot toggle — default OFF; read with `?? false`. */
  simplifyCustomFieldNames?: Maybe<boolean>;
  [name: string]: string | number | boolean | null | undefined;
}

export enum WidgetComponentType {
  Map = "map",
  Dashboard = "dashboard",
  Chart = "chart",
  ChartBeta = "chart beta",
  Sam = "sam",
  SamRfPv = "sam-rf-pv",
  Mpc = "mpc",
  XdaViewer = "xdaViewer"
}

export interface IWidgetScreenshot {
  widgetId: string;
  widgetComponentType: WidgetComponentType;
}

export interface IScreenshotAbbreviation {
  type: "system" | "org" | "user";
  current: string;
  abbreviation: string;
  caseSensitive: boolean;
}

export class ScreenshotError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ScreenshotError";
  }
}

export class ScreenshotNotFocusedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ScreenshotNotFocusedError";
  }
}
